import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Button, Spin2 } from "components";
import { toastAlert } from "@paylixecommerce/shared/components";
import { saveUserNotificationSettings } from "./actions";
import { useFormik } from "formik";
import { Switch } from "components/fields";


const Step2 = ({ settings, setStep, skipStep }) => {

	let [ loading, setLoading ] = useState(false);
	let [ initialValues, setInitialValues ] = useState({
		notifications_invoices: false,
		notifications_tickets: false,
		notifications_feedback: false,
		notifications_replies: false,
		notifications_product_updates: false,
		notifications_store_health: false,
		notifications_paylixecommerce: false
	});
	let dispatch = useDispatch();

	useEffect(() => {

		if(Object.keys(settings.user).length) {
			const { notifications_invoices, notifications_tickets, notifications_feedback, notifications_replies, notifications_product_updates, notifications_store_health, notifications_paylixecommerce } = settings.user

			setInitialValues({
				notifications_invoices: notifications_invoices,
				notifications_tickets: notifications_tickets,
				notifications_feedback: notifications_feedback,
				notifications_replies: notifications_replies,
				notifications_product_updates: notifications_product_updates,
				notifications_store_health: notifications_store_health,
				notifications_paylixecommerce: notifications_paylixecommerce
			});

		}
	}, [Object.keys(settings.user).length]);


	const onSubmit = (values) => {
		setLoading(true)
		dispatch(saveUserNotificationSettings({
			notifications_invoices: Boolean(values.notifications_invoices),
			notifications_tickets: Boolean(values.notifications_tickets),
			notifications_feedback: Boolean(values.notifications_feedback),
			notifications_replies: Boolean(values.notifications_replies),
			notifications_product_updates: Boolean(values.notifications_product_updates),
			notifications_store_health: Boolean(values.notifications_store_health),
			notifications_paylixecommerce: Boolean(values.notifications_paylixecommerce),
		}))
			.then(setStep)
			.catch(err => toastAlert('error', (err && err.error) || 'Something went wrong!'))
			.finally(() => {
				setLoading(false);
			})
	}

	let form = useFormik({initialValues, enableReinitialize: true, onSubmit})


	return (
		<div>
			<form onSubmit={form.handleSubmit}>

				<div className="position-relative">

					<h4>Notifications</h4>

					<Switch withBorder note="Receive an email when you make a new sale"  name="notifications_invoices" label="Orders" {...form} left />
					<Switch withBorder note="Receive an email when a ticket is created"  name="notifications_tickets" label="Tickets" {...form} left />
					<Switch withBorder note="Receive an email when a feedback is replied"  name="notifications_feedback" label="Feedback" {...form} left />
					<Switch withBorder note="Receive an email when a ticket is replied"  name="notifications_replies" label="Ticket Reply" {...form} left />
					<Switch withBorder note="Get an email when we release new features, updates or anything related to your store. We suggest leaving this enabled to be notified about your business."  name="notifications_product_updates" label="Product Updates" {...form} left />
					<Switch withBorder note="Receive emails to help you grow your business as well as best practices. Suggestions on how to keep a positive public image for both Paylix and your store."  name="notifications_store_health" label="Store Health and Best Practices" {...form} left />
					<Switch withBorder note="Allow the Paylix staff to send you friendly emails about social networks, blog posts or anything related to your social media experience and partnership!"  name="notifications_paylixecommerce" label="Paylix Friendly Emails" {...form} left />

				</div>

				<div className="setup-screen-step-buttons">
					<Button variant="secondary" size="large" type="button" onClick={skipStep}>
						Skip Step
					</Button>
					<Button variant="primary" size="large" type="submit">
						{loading ? <Spin2 /> : 'Next Step'}
					</Button>
				</div>

			</form>
		</div>
	)
}


export default Step2
